/**
 * Catchup controller
 * Show all CatchUps
 */

import { remove } from 'app/helpers/entity'

// controller mixins
CatchupCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * CatchupCtrl controller
 *
 * @class CatchupCtrl
 * @memberof mwApp/catchups
 * @see mwApp/catchups
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/catchups.controller:CatchupCtrl
 */
/* @ngInject */
export default function CatchupCtrl ($scope, $uibModal, Catchup, CatchupChannel, catchups, scope) {
  var vm = this

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  /**
   * CatchUps list
   *
   * @memberof mwApp/catchups.controller:CatchupCtrl
   * @name vm.catchups
   * @type {models.Catchup[]}
   */
  vm.catchups = catchups
  $scope.loading = false

  /**
   * Delete catchup
   *
   * @memberof mwApp/catchups.controller:CatchupCtrl
   * @param  {models.Catchup} cu
   */
  vm.deleteCatchup = function (cu) {
    cu._delete((cu.name || cu.channel.name) + ' Catchup deleted')
      .then(remove(vm.catchups)(cu))
  }

  $scope.getters = {
    caseInsensitiveName: function (row) {
      return row.channel.name.toLowerCase()
    },
    caseInsensitiveDescription: function (row) {
      return row.name.toLowerCase()
    }
  }

  /**
   * Edit catchup
   *
   * @memberof mwApp/catchups.controller:CatchupCtrl
   * @function
   * @param  {models.Catchup} cu
   */
  vm.editCatchup = null

  /**
   * Create catchup
   *
   * @memberof mwApp/catchups.controller:CatchupCtrl
   * @function
   * @param  {models.Catchup} cu
   * @param {Event} $event - jqLite event object
   */
  vm.addCatchup = vm.editCatchup = function (cu, $event) {
    vm.stopEvent($event)

    var isNew = !cu
    var initialCU = angular.copy(cu) // initial state
    $uibModal.open({
      templateUrl: 'components/services/views/addCatchUp.html',
      controller: 'AddCatchupCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        cu: function () {
          return !isNew
            ? cu
            : (scope.chnl ? new CatchupChannel() : new Catchup())
        },
        chnl: scope.chnl
      }
    }).result
      .then(
        function close (cu) {
          if (isNew) {
            vm.catchups.push(cu)
          }
        },
        function dismiss () {
          if (!isNew) {
            angular.copy(initialCU, cu) // restore catchup
          }
        }
      )
  }
}
